module.exports = __webpack_public_path__ + "img/icon-ranking-4@3x.697626ed.png";